module.exports = __webpack_public_path__ + "static/media/Rename.1d269071.svg";